export default __webpack_public_path__ + "media/Flowserve_logo.89bac738.png";